import React, { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import figoShield from '../../../assets/login/figo-shield-shine.svg';
import styles from './CustomerVerificationModal.module.css';
import { RoundButton } from '../RoundButton';
import { OtpFlow } from './OtpFlow';
import {
  retrieveExistingCustomerData,
  sendVerificationCode,
} from '../../../actions';

const CustomerVerificationWelcome = ({
  sendCode = () => { },
  onClose = () => { },
}) => {
  const { t } = useTranslation('login');
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <img alt="" src={figoShield} />

        <h1 className={styles.title}>{t('welcome')}</h1>

        <p className={styles.description}>
          <Trans
            components={{
              b: <b />,
            }}
            i18nKey="figoAccountFound"
            ns="login"
          />
        </p>
      </div>

      <RoundButton
        containerClassName={styles.sendCodeButton}
        onClick={sendCode}
        primary
      >
        {t('sendCode')}
      </RoundButton>

      <p className={styles.newAccount}>
        <Trans
          components={{
            a: (
              // eslint-disable-next-line jsx-a11y/control-has-associated-label
              <button
                className={styles.link}
                onClick={onClose}
                type="button"
              />
            ),
          }}
          i18nKey="preferedNewAccount"
          ns="login"
        />
      </p>
    </div>
  );
};

const CustomerVerificationOtp = ({ onValidationSuccess }) => (
  <div className={styles.container}>
    <OtpFlow onVerificationTokenRetrieved={onValidationSuccess} />
  </div>
);

export const CustomerVerificationModal = ({
  onDismiss = () => { },
  petRequest,
}) => {
  const [showWelcome, setShowWelcome] = useState(true);
  const store = useSelector(({ quoting }) => ({
    email: quoting.newCustomer.email,
    loadingLogin: quoting.sessionInformation.loadingLogin,
  }));
  const dispatch = useDispatch();
  const location = useLocation();

  const { email: emailFromStore, loadingLogin } = store;
  const email = useMemo(
    () => {
      const query = new URLSearchParams(location.search);
      return emailFromStore || query.get('email') || '';
    },
    [emailFromStore, location.search],
  );

  const sendCode = useCallback(() => {
    dispatch(sendVerificationCode({ email }));
    setShowWelcome(false);
  }, [dispatch, email]);

  const onValidationSuccess = useCallback(() => {
    if (!loadingLogin) {
      dispatch(retrieveExistingCustomerData({
        email,
        petQueryParams: petRequest,
      }));
    }
  }, [dispatch, email, loadingLogin, petRequest]);

  return (
    showWelcome ? (
      <CustomerVerificationWelcome
        onClose={onDismiss}
        sendCode={sendCode}
      />
    ) : (
      <CustomerVerificationOtp
        onValidationSuccess={onValidationSuccess}
      />
    )
  );
};
